import React from 'react';
export function SapperLogo({
  className = 'w-12 h-12'
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/vmzQYJYUCwVphHSGk8HUuF/sapper-hvac-logo.png" alt="Sapper HVAC" className={`object-contain ${className}`} data-id="element-293" />;
}